import React from "react";
import styles from "./ApprovedQuote.module.css";

import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Navigate } from "react-router-dom";

const ApprovedQuote = (props) => {
  return (
    <div style={{ marginTop: "5%", padding: "0% 10%", textAlign: "center" }}>
      <Card className={styles.cardMessage}>
        <div className={`pi pi-check-circle ${styles.checkCircleIcon}`}></div>
        <h1>{props.title}</h1>
        <p>{props.description}</p>
        <Button
          onClick={() => (window.location.href = props.buttonLink)}
          className={styles.button}
          label={props.buttonLabel}
        />
      </Card>
    </div>
  );
};

export default ApprovedQuote;
